import styled from 'styled-components'
import { default as VARIABLES } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const SupplierRegistrationForm = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;
  margin-top: 30px;
  box-shadow: 0 0 9px rgba(0, 0, 0, 0.16);

  /* Child element styles
  ------------------------------- */

  .main-content {
    min-height: calc(100vh - 267px);
    justify-content: center;
    padding-top: 60px;

    .content-body {
      max-width: 1422px;
      width: 100%;
    }
  }

  .form-wrapper {
    padding-left: 0;
    padding-right: 0;
    padding-top: 0;
  }

  .form-group {
    max-width: 100%;

    .message {
      height: auto;
    }
    .checkbox {
      margin-right: 50px;
    }

    .file {
      opacity: unset;
    }

    .react-datepicker__year-wrapper {
      display: flex;
      flex-wrap: wrap;
      max-width: 180px;
      align-content: center;
      justify-content: center;
    }
    .dNibMS {
      width: 500px;
    }

    .react-datepicker-wrapper
      .react-datepicker__input-container
      .date-picker-custom {
      color: ${VARIABLES.COLORS.GRAY_3};
      &:disabled {
        background-color: ${VARIABLES.COLORS.GRAY_8} !important;
        color: ${VARIABLES.COLORS.GRAY_10} !important;
      }
    }

    .input-upload-control {
      max-width: 500px;
      flex: 0 0 130px;
      min-width: 130px;
      margin-bottom: 10px;

      .fake-input-label {
        width: auto;
        flex: 0 1 auto;
      }
    }

    &.supplier-nation {
      margin-bottom: 20px;
    }

    & > label {
      flex: 0 0 190px;
    }

    &.select-time {
      .conjunction {
        padding: 0 12px;
      }
    }

    .option-currency {
      width: auto;
      max-width: inherit;
      margin-left: 10px;

      .test {
        width: 85px;
      }
    }
  }

  .form-wrapper {
    .input-control {
      max-width: 500px;
    }
  }

  .setup-password-form-caption {
    /* margin-bottom: 40px; */
    font-weight: ${VARIABLES.TYPOGRAPHYS.FONT_WEIGHT.FIRST_SEMI_BOLD};
    color: ${VARIABLES.COLORS.GRAY_3};
  }

  .setup-password-form {
    width: 100%;
    flex-wrap: wrap;

    .input-control {
      max-width: 500px;

      .label {
        flex: 0 0 190px;
        margin-right: 30px;
      }
    }

    .invalid-message {
      color: ${VARIABLES.COLORS.RED_1};
      font-size: ${VARIABLES.TYPOGRAPHYS.FONT_SIZES_PX.XS};
    }

    .button {
      margin-top: 36px;
      &.link {
        margin-top: 14px;
        width: 100%;
      }
    }
  }

  .mix-number-text {
    font-size: 12px;
    margin-top: 14px;
    margin-left: 15px;
    flex: 0 0 280px;
    color: ${VARIABLES.COLORS.GRAY_3};
  }

  .form-group .input-upload-control .fake-input-label {
    position: initial;
    z-index: inherit;
  }

  /* Modifiers
  ------------------------------- */

  /* Media queries
  ------------------------------- */
  @media all and (min-width: 900px) {
    .form-wrapper:has(.regis-capital > input:focus) {
      .form-group {
        .regis-address,
        .country,
        .contact-address,
        .phone,
        .fax,
        .email,
        .website,
        .tooltip-upload {
          color: #06304f;
        }
      }
    }
  }
`
